import jsonFetch from "utils/jsonFetch";

const login = (email, password) =>
  jsonFetch(`${apiUrl}${version}/users/sign_in`, {
    method: "POST",
    json: {
      user: {
        email,
        password,
      },
    },
  });

export default login;
